<template>
  <div
    @click="scrollToTop"
    class="back-to-top-btn d-flex align-items-center justify-content-center"
  >
    <i class="km-arrow-top" />
  </div>
</template>
<script setup>
const scrollToTop = () => {
  const snapWrap = document.querySelector(".page-wrap--snap");
  if (snapWrap) {
    snapWrap.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  window.scrollTo({ top: 0, behavior: "smooth" });
};
</script>
